import styled from 'styled-components';

import { HorizontalCenterBlock, VerticalHorizontalCenterBlock } from '../../../styled';

export const CustomizationFrameWrapper = styled.div`
  border-radius: 4px;
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const CodeEditorFrame = styled.div`
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const WidgetFrame = styled(VerticalHorizontalCenterBlock)`
  border-radius: inherit;
  height: 634px;
  background: ${(props) => props.theme.colors.tableCell};
`;

export const WidgetSettingsTitle = styled.h2`
  ${(props) => props.theme.typography.subHeader2};
  margin-bottom: 8px;
`;

export const WidgetSettingsDescription = styled.p`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 8px;
`;

export const NotificationWrapper = styled.div`
  margin-bottom: 24px;
`;

export const LocaleOptionWrapper = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
`;

export const WidgetSettingsWrapper = styled(HorizontalCenterBlock)`
  margin-top: 25px;
  margin-bottom: 44px;
`;

export const FooterWrapper = styled.div`
  width: 100%;
`;
